import React from 'react';
const NotFound = () => (React.createElement(React.Fragment, null, "Not found"));
NotFound.displayName = 'NotFound';
export default NotFound;
